import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

const About = () => {
  return (
    <div>
      <Helmet>
        <title>About Holy See Bright Academy – 30 Years of Educational Excellence</title>
        <meta 
          name="description" 
          content="Holy See Bright Academy: Founded 1995. #1 in WAEC/NECO results. Official JAMB/WAEC/NECO CBT Centre. Catholic school with holistic education in Nigeria." 
        />
        <meta name="keywords" content="about Holy See Bright Academy, school history, mission vision, Catholic education Nigeria, academic excellence, school achievements" />
        <link rel="canonical" href="https://holyseebright.com/about" />
      </Helmet>
      
      <Header />
      <main style={{ minHeight: '70vh', padding: '40px 20px' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1>About Holy See Bright Academy</h1>
          <p><strong>Excellence in Education Since 1995</strong></p>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>🏫 Our History</h2>
            <p>Founded in 1995, Holy See Bright Academy has been at the forefront of providing quality Catholic education in Nigeria for nearly three decades. From humble beginnings, we have grown to become one of Nigeria's most respected educational institutions, consistently producing top performers in national examinations.</p>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>🎯 Our Mission</h2>
            <p>To provide holistic Catholic education that combines academic excellence with moral and character development, preparing students to become responsible Christian leaders and productive global citizens.</p>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>👁️ Our Vision</h2>
            <p>To be Nigeria's leading Catholic educational institution, recognized for producing well-rounded individuals who excel academically, morally, spiritually, and socially.</p>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>🏆 Accreditations & Achievements</h2>
            <ul>
              <li>✅ #1 in WAEC/NECO/NABTECH/WASSCE Results (Consistently top 1%)</li>
              <li>✅ Official JAMB/WAEC/NECO Computer-Based Test Centre</li>
              <li>✅ Accredited by Federal Ministry of Education</li>
              <li>✅ 30+ Years of Educational Excellence</li>
              <li>✅ National School Sports Champions 2023</li>
            </ul>
          </div>
          
          <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', margin: '30px 0' }}>
            <h2>📍 Campus Location</h2>
            <p>Our main campus is located at No. 1 Emmanuel Street, Jeun Amawa, Karu LGA, Nasarawa State - strategically positioned to serve families in Abuja and surrounding states.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About;
